@use '@/styles/tokens' as *;

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-bottom: var(--space-4);
}

.label {
  padding-inline: var(--space-2);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

// Decorative required marker — rendered via ::after so it stays out of the
// label's accessible name (getByLabelText('Phone Number') still matches).
.requiredLabel::after {
  content: ' *';
  color: $color-error-900;
}

// Help and error text are inset to the same `--space-2` as the label, so the three lines a field
// can show all start on one vertical edge instead of the message hanging off the input's left.
.help {
  padding-inline: var(--space-2);
  font-size: 12px;
  color: var(--text-muted);
}

.error {
  padding-inline: var(--space-2);
  // Was 11px/300 — too faint and too small to read next to the 14px label it sits under.
  font-size: 12px;
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
  color: $color-error-900;
}
